import iconStackedRebrand from '@/assets/logos/icon-stacked-svg/icon-stacked-rebrand.svg';
import { cn } from '@/lib/cn';
import Image, { type ImageProps } from 'next/image';

export const BrandIconStackedSvg = (props: Omit<ImageProps, 'src'>) => {
  const { alt, className, ...rest } = props;

  return (
    <Image
      {...rest}
      src={iconStackedRebrand}
      alt={alt}
      className={cn('dark-invert', className)}
    />
  );
};
